import { fetchPasswordResetToken } from 'src/modules/routing/hooks/resolvers/fetchPasswordResetToken';
import { resetPasswordResetToken } from 'src/modules/routing/hooks/resolvers/resetPasswordResetToken';
import { createStateTransitionLoggingSaga } from 'src/modules/routing/hooks/stateTransitionLogging';
import { RouteState } from 'src/modules/routing/types/RouteState';
import { composeSagas } from 'src/modules/routing/utils/composeSagas';

export const ROUTING_LOGIN_STATES: ReadonlyArray<RouteState> = [
  {
    url: '/login',
    name: 'bp:login',
    parent: 'bp:anonymous',

    onEntering: composeSagas(
      createStateTransitionLoggingSaga('Entering'),
    ),
    onLeaving: composeSagas(
      createStateTransitionLoggingSaga('Leaving'),
    ),
    onRetaining: composeSagas(
      createStateTransitionLoggingSaga('Retaining'),
    ),

    onEntered: composeSagas(
      createStateTransitionLoggingSaga('Entered'),
    ),
    onLeft: composeSagas(
      createStateTransitionLoggingSaga('Left'),
    ),
    onRetained: composeSagas(
      createStateTransitionLoggingSaga('Retained'),
    ),
  },
  {
    url: '/password/forgot',
    name: 'bp:password:forgot',
    parent: 'bp:anonymous',

    onEntering: composeSagas(
      createStateTransitionLoggingSaga('Entering'),
    ),
    onLeaving: composeSagas(
      createStateTransitionLoggingSaga('Leaving'),
    ),
    onRetaining: composeSagas(
      createStateTransitionLoggingSaga('Retaining'),
    ),

    onEntered: composeSagas(
      createStateTransitionLoggingSaga('Entered'),
    ),
    onLeft: composeSagas(
      createStateTransitionLoggingSaga('Left'),
    ),
    onRetained: composeSagas(
      createStateTransitionLoggingSaga('Retained'),
    ),
  },
  {
    url: '/password/reset',
    name: 'bp:password:reset',
    parent: 'bp:anonymous',

    onEntering: composeSagas(
      createStateTransitionLoggingSaga('Entering'),
      fetchPasswordResetToken,
    ),
    onLeaving: composeSagas(
      createStateTransitionLoggingSaga('Leaving'),
    ),
    onRetaining: composeSagas(
      createStateTransitionLoggingSaga('Retaining'),
      fetchPasswordResetToken,
    ),

    onEntered: composeSagas(
      createStateTransitionLoggingSaga('Entered'),
    ),
    onLeft: composeSagas(
      createStateTransitionLoggingSaga('Left'),
      resetPasswordResetToken,
    ),
    onRetained: composeSagas(
      createStateTransitionLoggingSaga('Retained'),
    ),
  },
  {
    url: '/password/setup',
    name: 'bp:password:setup',
    parent: 'bp:anonymous',

    onEntering: composeSagas(
      createStateTransitionLoggingSaga('Entering'),
      fetchPasswordResetToken,
    ),
    onLeaving: composeSagas(
      createStateTransitionLoggingSaga('Leaving'),
    ),
    onRetaining: composeSagas(
      createStateTransitionLoggingSaga('Retaining'),
      fetchPasswordResetToken,
    ),

    onEntered: composeSagas(
      createStateTransitionLoggingSaga('Entered'),
    ),
    onLeft: composeSagas(
      createStateTransitionLoggingSaga('Left'),
      resetPasswordResetToken,
    ),
    onRetained: composeSagas(
      createStateTransitionLoggingSaga('Retained'),
    ),
  },
];
